import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = {
  id: string;
  name: string;
  title?: string | null;
  practiceAreaSlugs: string[];
  barAdmissions: string[];
};

export default function AttorneysPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ attorneys: Row[] }>("/api/v1/tenant/attorneys");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("attorneys.title")}</h1>
      <DataTable
        rows={data?.attorneys ?? null}
        loading={loading}
        error={error}
        empty={t("attorneys.empty")}
        columns={[
          { header: t("attorneys.col.name"), render: (r) => r.name },
          { header: t("attorneys.col.title"), render: (r) => r.title ?? "—" },
          {
            header: t("attorneys.col.practice"),
            render: (r) => r.practiceAreaSlugs.join(", ") || "—",
          },
          {
            header: t("attorneys.col.bar"),
            render: (r) => r.barAdmissions.join(", ") || "—",
          },
        ]}
      />
    </div>
  );
}
